var exports = {
  "show-commit-selector-on-small": "show-commit-selector-on-small__F2tccn",
  "show-commit-selector-on-medium": "show-commit-selector-on-medium__6QmXex",
};

__webpack_require__.r(module.exports = exports);
